export function matchFav<T>(item: T, isEnabled: boolean) {
  if (isEnabled) {
    return (item as any).i_follow === true;
  }

  return true;
}

export function matchCreatedBy<T>(item: T, userId: string, isEnabled: boolean) {
  if (isEnabled) {
    return (item as any).created_by === userId;
  }

  return true;
}

export function matchTeam<T>(
  item: T,
  lookup: any,
  teamId: string,
  isEnabled: boolean,
) {
  if (isEnabled) {
    const l = lookup[(item as any).created_by];
    return l && l.team === teamId;
  }

  return true;
}
